// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutUsTextModule_container__Dk7mS","bolder":"AboutUsTextModule_bolder__O8seF"};